import { useRef } from 'react'

import { useTranslation } from 'react-i18next'

import avatarPlaceholder from 'assets/images/user_placeholder.png'
import AvatarHolder from 'components/UI/AvatarHolder/AvatarHolder'
import GroupsDropdown from 'features/GroupsDropdown/GroupsDropdown'
import { useUserProfile } from 'store'
import { type IGroup } from 'types/interfaces/ITypes'

interface PostVisibilityProps {
  isEdit: boolean
  audience: IGroup[]
  groups: IGroup[]
  setAudience: (val: IGroup[]) => void
}

export const PostVisibility = ({
  audience,
  groups,
  setAudience,
  isEdit
}: PostVisibilityProps) => {
  const userData = useUserProfile()
  const { t } = useTranslation()
  const groupsDropdownRef = useRef<any>()

  const handleOpen = () => {
    // disable opening when editing
    if (isEdit) return
    if (groupsDropdownRef.current?.openDropdown) {
      groupsDropdownRef.current.openDropdown()
    }
  }

  return (
    <div className='newpost__visibility'>
      <div className='newpost__user'>
        <AvatarHolder
          img={userData?.avatar?.url ?? avatarPlaceholder}
          size='50'
          hasStory={true}
          storyRead={false}
        />
      </div>

      <div
        className={`newpost__visibility__select ${isEdit ? 'disabled' : ''}`}
        onClick={handleOpen}
        style={isEdit ? { opacity: 0.6, pointerEvents: 'none' } : undefined}
      >
      <GroupsDropdown
        groups={groups}
        apply={(selectedValue: IGroup[]) => setAudience(selectedValue)}
        headText='All'
        preview={audience}
        isEdit={isEdit}
        hasCloseButton={true}
        ref={groupsDropdownRef}
      />
      </div>
    </div>
  )
}
